import useAppContext from "./use-app-context";

export default function useDispatch() {
  const {dispatch} = useAppContext();

  return dispatch;
}
